import React, { useEffect, useMemo, useState } from 'react';
import { translate } from '../../Services/translation';
import Collapsible from '../Collapsible';
import CustomVariantCalculatorContainer from './CustomVariantCalculatorContainer';
import BuyButton from '../BuyButton';

const CustomVariantContainer = ({
  configurations,
  storesUrl,
  isBuyableChannel,
  isB2b,
}) => {
  const SAMPLE_TYPE = 'Sample';
  const [openCollapsible, setOpenCollapsible] = useState(
    configurations?.length == 1 ? [0] : null
  );
  const getDisplayPrice = (config) => {
    if (config.campaignPricePerUnit) {
      return (
        <div>
          <span style={{ fontWeight: 400 }} className="text-linethrough">
            {config.pricePerUnit}
            {config.currencySymbol}/
            {getUnitOfMessurment(config.unitOfMeasurement)}
          </span>
          <span className="color-error-700">
            {' '}
            {config.campaignPricePerUnit}
            {config.currencySymbol}/
            {getUnitOfMessurment(config.unitOfMeasurement)}
          </span>
        </div>
      );
    }
    return (
      <div>
        {config.pricePerUnit}
        {config.currencySymbol}/{getUnitOfMessurment(config.unitOfMeasurement)}
      </div>
    );
  };

  const getUnitOfMessurment = (unit) => {
    if (unit == 'm2') {
      return 'm²';
    }
    return unit;
  };

  const getLabel = (config) => {
    return (
      <div className="d-flex">
        <span>{translate(`calculator.${config.configuratorType}`)}</span>
        {config.configuratorType != SAMPLE_TYPE && (
          <div className="d-flex">
            &nbsp;(<span>{getDisplayPrice(config)}</span>)
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="custom-variant">
      {configurations.map((config, index) => {
        return (
          <Collapsible
            key={config.articleNumber}
            isOpen={openCollapsible == index}
            onStateChange={(open) => setOpenCollapsible(open ? index : null)}
            className="header-6 collapsible-header"
            transitionDuration="0.1"
            label={getLabel(config)}
          >
            {config.configuratorType === 'Sample' && (
              <div>
                <div className="[ custom-variant__description ] [ text-medium lh-2 ]">
                  {translate('product-page.custom-size.sample-description')}
                </div>
                {isBuyableChannel ? (
                  <BuyButton
                    label={translate('product-page.buy-button')}
                    cssClass={'buy-button'}
                    quantity={1}
                    articleNumber={config.articleNumber}
                  />
                ) : (
                  <a className="buy-button" href={storesUrl}>
                    {translate('product-page.find-your-store')}
                  </a>
                )}
              </div>
            )}
            {config.configuratorType !== 'Sample' && (
              <CustomVariantCalculatorContainer
                {...config}
                storesUrl={storesUrl}
                isBuyableChannel={isBuyableChannel}
                isB2b={isB2b}
              />
            )}
          </Collapsible>
        );
      })}
    </div>
  );
};

export default CustomVariantContainer;
